import { FilterValue } from "antd/lib/table/interface";
import DataTable from "../common/components/DataTable";
import MainLayout from "../common/components/MainLayout";
import useConfiguracionJuzgadoApi, { ConfiguracionJuzgado, ConfiguracionJuzgadoSave } from "./useJuzgadoConfiguracionApi";
import { Input, Table } from "antd";
import DataFilter from "../common/components/DataFilter";
import { Form } from "antd";
import EditableCell from "../common/components/EditableCell";

const JuzgadoConfiguracionList = () => {
    const api = useConfiguracionJuzgadoApi();
    const createPage = "/juzgado/configuraciones/guardar";
    const editPage = "/juzgado/configuraciones/guardar/{Id}";
    const [ idFilterForm ] = Form.useForm();
    const [nombreFilterForm] = Form.useForm();
    // Filtros
    const generateFilters = (filters:Record<string, FilterValue | null>) => {
        return [
            filters?.Nombre != null ?  `contains(Nombre,'${filters!.nombre![0]}')` : "",
        ];
    }
    return (
        <MainLayout>
            <DataTable<ConfiguracionJuzgado, ConfiguracionJuzgadoSave>
                list = { api.list }
                delete = { api.delete }                
                createAction = { {
                    label: "Agregar configuración de Juzgado",
                    path: createPage
                } }
                defaultSortOrder={ "Id asc" }
                title = { "Configuraciones de Juzgado" }
                editItemAction = { editPage }
                generateFilters = { generateFilters }
                deleteItemAction
                deleteItemActionConfirmMessage = { (item) => `¿Eliminar configuración ${item.Nombre}?` }
                defaultPageSize = { 25 }
            >
                <Table.Column<ConfiguracionJuzgado>
                    width = { `5%` }
                    title = "Id"
                    dataIndex = { "Id" }
                    defaultSortOrder = { 'descend' }
                    sortDirections = { ["ascend","descend","ascend"] }
                    filterDropdown={(props) => {
                        return (
                          <DataFilter
                            filterDropdownProps = { props }
                            form = { idFilterForm }
                          >
                            <Form.Item name = { "Id" } style = { { marginBottom: 10 } } >
                              <Input placeholder = "Nro Acta..."/>
                            </Form.Item>
                          </DataFilter>
                        );
                    }}
                />
                <Table.Column<ConfiguracionJuzgado>
                    width = {`30%`}
                    title = "Nombre"
                    dataIndex = { "Nombre" }
                    sorter
                    render = {(val, record) =>
                        <EditableCell<Partial<ConfiguracionJuzgado>>
                            save = { api.save }
                            id = { record.Id }
                            render = { (value) => {
                                return value.Nombre
                            } }
                            formValue = { { Nombre: val } }
                            formItem = { <Form.Item style={{ marginBottom: 0 }} name={ "Nombre" } ><Input maxLength={150} /></Form.Item> }
                            value = { record }
                        />
                    }
                    defaultSortOrder = { 'descend' }
                    sortDirections = { ["ascend", "descend", "ascend"] }
                    filterDropdown = { (props) => {
                        return (
                            <DataFilter filterDropdownProps = {props} form = {nombreFilterForm} >
                                <Form.Item name = { "Nombre" } style = { { marginBottom: 10 } }>
                                    <Input placeholder = 'Nombre...'/>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                    }
                />
            </DataTable>
        </MainLayout>
    )
};

export default JuzgadoConfiguracionList;